import { NgModule } from '@angular/core';
import { ReservationsComponent } from './reservations.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ReservationsRoutingModule } from './reservations-routing.module';
import { SharedModule } from '../shared/shared.module';
import { ReservationService } from '../reservations/reservations.service';
import { MatStepperModule } from '@angular/material/stepper';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatInputModule } from '@angular/material/input';
import { FileUploadModule } from 'ng2-file-upload';

@NgModule({
  imports: [ReservationsRoutingModule, SharedModule, ReactiveFormsModule, FileUploadModule, MatFormFieldModule, MatInputModule, MatCheckboxModule, MatSelectModule, MatRadioModule, MatStepperModule],
  declarations: [ReservationsComponent],
  exports: [ReservationsComponent],
  providers: [ReservationService]
})
export class ReservationsModule { }
